/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeCadenceRequest
 */
export interface ChangeCadenceRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeCadenceRequest
     */
    newCadence: ChangeCadenceRequestNewCadenceEnum;
    /**
     * 
     * @type {string}
     * @memberof ChangeCadenceRequest
     */
    timezone?: string;
}


/**
 * @export
 */
export const ChangeCadenceRequestNewCadenceEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY',
    Yearly: 'YEARLY'
} as const;
export type ChangeCadenceRequestNewCadenceEnum = typeof ChangeCadenceRequestNewCadenceEnum[keyof typeof ChangeCadenceRequestNewCadenceEnum];


/**
 * Check if a given object implements the ChangeCadenceRequest interface.
 */
export function instanceOfChangeCadenceRequest(value: object): value is ChangeCadenceRequest {
    if (!('newCadence' in value) || value['newCadence'] === undefined) return false;
    return true;
}

export function ChangeCadenceRequestFromJSON(json: any): ChangeCadenceRequest {
    return ChangeCadenceRequestFromJSONTyped(json, false);
}

export function ChangeCadenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeCadenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newCadence': json['newCadence'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

export function ChangeCadenceRequestToJSON(json: any): ChangeCadenceRequest {
    return ChangeCadenceRequestToJSONTyped(json, false);
}

export function ChangeCadenceRequestToJSONTyped(value?: ChangeCadenceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newCadence': value['newCadence'],
        'timezone': value['timezone'],
    };
}

